import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-long-right', 'ArrowLongRight', [["path",{"d":"m18 16 4-4-4-4m4 4H2","key":"svg-0"}]]);